/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @author Viacheslav Smalenski
 * @version 1.28.0
 * @since 1.22.0
 */

import EFormValidation from '@modules/form/const/formValidation';
import { ICommonTranslation } from '@modules/internationalization/types';
import { IAuthFileUploadLimits } from '@pages/PageAuth/types/authTypes';
import { stringFormatParams } from '@utils/stringFormat';

export const getAttachFileErrorMessage = (
    translation: ICommonTranslation,
    error: EFormValidation,
    fileLimits: IAuthFileUploadLimits,
    allowedFileExtensions: string[] = [],
) => {
    switch (error) {
        case EFormValidation.fileFormatIncorrect:
            return stringFormatParams(translation.form.validation[EFormValidation.fileFormatIncorrect], {
                format: allowedFileExtensions.join(', '),
            });
        case EFormValidation.fileSizeExceeded:
            return stringFormatParams(translation.form.validation[EFormValidation.fileSizeExceeded]);
        case EFormValidation.fileNameTooLong:
            return stringFormatParams(translation.form.validation[EFormValidation.fileNameTooLong], {
                nameLimit: fileLimits.maxFileNameLength,
            });
        default:
            return translation.form.validation[error];
    }
};
